import styled from "styled-components";
import ThemeColors from "../../../../themes/colors";

export const MainContainer = styled.div`
  background-color: ${ThemeColors.Black900};
  padding: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ActionContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-right: 2rem;
`;

export const Logo = styled.img`
  height: 1.6rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
`;

export const OptionItem = styled.div`
  cursor: pointer;
`;
